import TR from 'utils/TR';
import Segment from 'components/common/Segment';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';

export default function MBTIPatternBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    week_days_bld_sugr_mbti,
    weekend_bld_sugr_mbti,
  } = data || {};

  return (
    <Segment {...ex(['OverviewSummaryBox', 'MBTIPatternBox'], rest)}>
      <div>
        {T('혈당패턴')}
      </div>
      <div>
        <VBox>
          <HBox>
            <div {...ex('MBTICaption')}>
              {T('주중')}
            </div>
            <div {...ex('MBTIPattern')}>
              {week_days_bld_sugr_mbti}
            </div>
          </HBox>
          <HBox>
            <div {...ex('MBTICaption')}>
              {T('주말')}
            </div>
            <div {...ex('MBTIPattern')}>
              {weekend_bld_sugr_mbti}
            </div>
          </HBox>
        </VBox>
      </div>
    </Segment>
  );
}
